/* Sweet Crème — Build Your Box flavor picker
 * Enforces "up to N flavors", splits the box evenly across the chosen flavors,
 * writes the selection into hidden line-item-property inputs, moves those inputs
 * into the product form so they post on Add to Cart, and blocks Add to Cart
 * until at least one flavor is chosen.
 *
 * The picker is rendered via a custom_liquid block, which sits OUTSIDE the
 * product <form>, so we relocate the hidden property inputs into the form.
 */
(function () {
  function evenSplit(total, n) {
    var base = Math.floor(total / n);
    var rem = total % n;
    var out = [];
    for (var i = 0; i < n; i++) out.push(base + (i < rem ? 1 : 0));
    return out;
  }

  function findProductForm(root) {
    // Prefer the add-to-cart form within the same product section, else page-wide.
    var scope = root.closest('.product, .shopify-section') || document;
    return (
      scope.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('product-form form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[action$="/cart/add"]')
    );
  }

  function initByo(root) {
    if (root.dataset.scByoReady === '1') return;
    root.dataset.scByoReady = '1';

    var max = parseInt(root.dataset.max || '4', 10);
    var box = parseInt(root.dataset.boxSize || '12', 10);
    var checkboxes = Array.prototype.slice.call(root.querySelectorAll('.sc-byo__cb'));
    var countEl = root.querySelector('[data-sc-count]');
    var mixEl = root.querySelector('[data-sc-mix]');
    var hintEl = root.querySelector('[data-sc-hint]');
    var propFlavors = root.querySelector('[data-sc-prop-flavors]');
    var propMix = root.querySelector('[data-sc-prop-mix]');

    var form = findProductForm(root);
    var submitBtn = form ? form.querySelector('[name="add"]') : null;

    // Move the hidden property inputs into the form so they're submitted.
    if (form) {
      if (propFlavors) form.appendChild(propFlavors);
      if (propMix) form.appendChild(propMix);
    }

    function update() {
      var chosen = checkboxes.filter(function (c) { return c.checked; });
      var n = chosen.length;

      checkboxes.forEach(function (c) {
        var opt = c.closest('.sc-byo__opt');
        var atLimit = !c.checked && n >= max;
        c.disabled = atLimit;
        if (opt) {
          opt.classList.toggle('is-disabled', atLimit);
          opt.classList.toggle('is-checked', c.checked);
        }
      });

      if (countEl) countEl.textContent = n + ' of ' + max + ' selected';

      if (n > 0) {
        var counts = evenSplit(box, n);
        var names = chosen.map(function (c) { return c.value; });
        var mixParts = names.map(function (nm, i) { return nm + ' ×' + counts[i]; });
        if (propFlavors) propFlavors.value = names.join(', ');
        if (propMix) propMix.value = mixParts.join(', ');
        if (mixEl) {
          mixEl.hidden = false;
          mixEl.textContent = 'Your box of ' + box + ': ' + mixParts.join(' · ');
        }
        if (hintEl) hintEl.hidden = true;
      } else {
        if (propFlavors) propFlavors.value = '';
        if (propMix) propMix.value = '';
        if (mixEl) { mixEl.hidden = true; mixEl.textContent = ''; }
        if (hintEl) hintEl.hidden = false;
      }

      if (submitBtn) {
        if (n < 1) {
          submitBtn.setAttribute('disabled', 'disabled');
          submitBtn.dataset.scBlocked = '1';
        } else if (submitBtn.dataset.scBlocked === '1') {
          submitBtn.removeAttribute('disabled');
          delete submitBtn.dataset.scBlocked;
        }
      }
    }

    checkboxes.forEach(function (c) { c.addEventListener('change', update); });
    update();
  }

  function boot() {
    document.querySelectorAll('[data-sc-byo]').forEach(initByo);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', boot);
})();
